'use strict';

import { ModalManager } from './ModalManager.js';
import { nextFrame } from './asyncTools.js';
import { copy } from './clipboardTools.js';

const optionsMenu = {
    _filters: [],
    _copyHandlers: [],
    lastClickedEl: null,
    opened: false,
    init: false,
    boxSelector: '.chatItem',

    addOpenFilter: function (filter) {
        this._filters.push(filter);
    },
    addCopyHandler: function (handler) {
        this._copyHandlers.push(handler);
    },

    open: async function(param) {
        const offsetX = 15;
        const offsetY = 10;
        const $overlay = $('<span class="overlayOutclicker options"></span>');

        this.lastClickedEl = param.el;
        let targetTop = (param.event.pageY || 0) + 5 + offsetY;

        //console.log('Opening options menu for element', targetTop, (param.event.pageY || 0));
        //console.log('ModalManager.isReleasing', ModalManager.isReleasing);
        if (ModalManager.isReleasing) {
            await ModalManager.releasePromise;
            await nextFrame();

            const box = param.el.getBoundingClientRect();
            targetTop = box.top + box.height + window.scrollY + 5 + offsetY;
        }

        // aizveram vecos ja ir;
        $('.cht2fld-options').remove();
        $('.overlayOutclicker.options').remove();

        $('body').append(
            // @ts-ignore
            $('.cht2fld-options-tpl').first().clone().each(function () {
                // @ts-ignore
                this.targetEl = param.el;

                if (optionsMenu._filters.length > 0) {
                    optionsMenu._filters.forEach(filter => {
                        filter(this, param.el);
                    });
                }
            }).addClass('cht2fld-options').removeClass('cht2fld-options-tpl').css({
                top: targetTop,
                left: (param.event.pageX || 0) + 5 + offsetX
            })
        );

        // @ts-ignore
        $('.cht2fld-options').before($overlay).each(function () {
            // @ts-ignore
            this.overlayEl = $overlay.get(0);
            const offset = $(this).offset();
            const leftWidth = $(this).outerWidth();
            const topHeight = $(this).outerHeight();

            if (offset.left + leftWidth > $(window).width()) {
                $(this).css({
                    left: (offset.left - leftWidth - 25) + 'px'
                });
            }
            if (offset.top + topHeight > $(window).height() + $(window).scrollTop()) {
                $(this).css({
                    top: (offset.top - topHeight - 25) + 'px'
                });
            }
        });

        this.initOutclick();
        this.opened = true;
    },
    close: function(param) {
        if (param && param.el) {
            if (param.el.overlayEl) {
                $(param.el.overlayEl).remove();
            } else {
                $('.overlayOutclicker.options').remove();
            }
            $(param.el).remove();
            return $('.cht2fld-options').length == 0;
        }

        $('.cht2fld-options').remove();
        $('.overlayOutclicker.options').remove();
        return true;
    },

    initOutclick: function() {
        if (this.init) return;
        this.init = true;

        $('body').on('click.optionsMenu', '.cht2fld-options', function(event) {
            event.stopPropagation();
        });

        $(window).on('jq-outclick.optionsMenu', (event, clickEvent) => {
            if (clickEvent && clickEvent.target === this.lastClickedEl) {
                this.lastClickedEl = null;
                return;
            }
            if (this.opened) {
                if (this.close()) {
                    this.opened = false;
                }
            }
        });
    },
    currentBox: function(boxSelector = null) {
        var box = null;
        $('.cht2fld-options').last().each(function () {
            // @ts-ignore
            if (this.targetEl) {
                // @ts-ignore
                $(this.targetEl).closest(boxSelector || optionsMenu.boxSelector).each(function () {
                    box = this;
                });
            }
        });
        return box;
    },
    currentBoxId: function(boxSelector = null) {
        var box = this.currentBox(boxSelector);
        return box ? $(box).data('id') : null;
    },
    copyAction: function(el, event) {
        var box = this.currentBox();
        if (box) {
            var textItems = [];

            if (optionsMenu._copyHandlers.length > 0) {
                optionsMenu._copyHandlers.forEach(function (handler) {
                    handler(textItems, box);
                });
            }
            if (textItems.length === 0) {
                // default copy logic - kopējam visu tekstu, kas ir zem .text klases
                $(box).find('.text').each(function () {
                    textItems.push(optionsMenu.cleanText(this));
                });
            }

            var text = textItems.join('');
            var newlineAdded = text.indexOf('\n') >= 0;

            var $tmp = $('<'+(newlineAdded ? 'textarea' : 'input type="text"')+' class="clipboardInput2">').css({
                top: (event.pageY || 0) + 5,
                left: (event.pageX || 0) + 5
            }).val(text);
            $('body').append($tmp);

            copy($tmp.get(0), function () {
                $tmp.remove();
                $(el).addClass('copied');

                setTimeout(function () {
                    $(window).trigger('jq-chat-option-menu', { action: 'close', el: $(el).closest('.cht2fld-options').get(0) });
                }, 2000);
            });
        };
    },
    cleanText: function(el) {
        let $clone = $(el).clone();
        var emoji;

        // @ts-ignore
        if (typeof EmojiConvertor == 'undefined') {
            // @ts-ignore
            emoji = new EmojiConvertor();
        } else {
            emoji = null;
        }

        $clone.find('.emji').each(function () {
            var emojiCode = $(this).data('e');
            if (!emojiCode) {
                var tmp = this.className.replace('emji e', '');
                if (emoji && emoji.data[tmp]) {
                    emojiCode = emoji.data[tmp][0][0];
                }
            }
            if (emojiCode) {
                $(this).replaceWith(emojiCode);
            }
        });

        $clone.find('a').each(function () {
            if ($(this).data('orig')) {
                $(this).replaceWith($(this).data('orig'));
                return;
            }
            if ($(this).hasClass('timestamp')) {
                $(this).replaceWith($(this).text());
            } else {
                $(this).replaceWith($(this).attr('href'));
            }
        });

        let text = $clone.text();
        $clone.remove();
        return text;
    }
};

export { optionsMenu };
